import { setLoadingMessage } from '../../redux/Slice/globalStates';
import {
  add_new_assets,
  addAudio,
  addSceneAudio,
  selected_object,
  set_is_audio_editoropen,
  setAudioScales,
  setPushIntersectedObject,
  update_assets_data,
} from '../../redux/Slice/gridSlice';
import store from '../../redux/store';
import { getNextCopyName, buildTempFileName } from '../../utils/NamingUtils';
import { copyPhysicsToDuplicate } from '../../utils/Physics/PhysicsUtils';
import AudioIcon from '../../assets/images/icons/MusicNote.png'; // Import AudioIcon from util.js
import { selectObjectInScene } from '../../pages/Dashboard/GridPage';
import toast from 'react-hot-toast';
import { applyStoredPivotToObject } from '../../utils/ThreeJsUtils/pivotEditor';



export function handleAudioUpload(
  e,
  { Three, scene, transformControls, camera, selectedObject, setPolyCount },
  setPendingUploads // Optional for storing file before publishing
) {
  if (!e.target.files || e.target.files.length === 0) {
    return;
  }

  const file = e.target.files[0];
  const maxSize = 5 * 1024 * 1024; // 5MB size limit

  if (file.size > maxSize) {
    toast.error(
      () => (
        <div className="flex justify-between items-center">
          <span>File size should not exceed 5MB.</span>
        </div>
      ),
      {
        duration: 3000, // auto close after 5 seconds
        style: {
          background: '#1d1e21',
          color: '#fff',
        },
      }
    );
    return;
  }

  selectedObject = null;
  store.dispatch(selected_object(null));
  transformControls.detach();
  store.dispatch(setLoadingMessage(true));

  const objectURL = URL.createObjectURL(file);
  const tempId = `temp-${Date.now()}-${file.name}`;

  const audio = document.createElement('audio');
  audio.autoplay = false;
  audio.src = objectURL;
  audio.crossOrigin = 'anonymous';
  audio.load();

  audio.addEventListener('loadeddata', () => {
    // Load audio icon texture from SVG
    const texture = loadAudioIconTexture(Three, AudioIcon);

    const material = new Three.MeshStandardMaterial({
      map: texture,
      side: Three.DoubleSide,
    });

    const geometry = new Three.PlaneGeometry(1, 1);
    const audioMesh = new Three.Mesh(geometry, material);
    audioMesh.castShadow = true;
    audioMesh.receiveShadow = true;
    //audioMesh.scale.x = -audioMesh.scale.x;

    // Set metadata
    audioMesh.name = tempId;
    audioMesh.objPath = file;
    audioMesh.url = tempId;
    audioMesh._id = tempId;
    audioMesh.file_name = file.name;
    audioMesh.deleteType = 'audio';
    audioMesh.originalFile = file;
    audioMesh.localFile = file;
    // Store file for later upload if needed
    if (setPendingUploads) {
      setPendingUploads((prev) => [
        ...prev,
        {
          file: file,
          transform: {
            position_x: 0,
            position_y: 0,
            position_z: 0,
            rotation_x: 0,
            rotation_y: 0,
            rotation_z: 0,
            scale_x: 1,
            scale_y: 1,
            scale_z: 1,
          },
          tempId: tempId,
        },
      ]);
    }

    // Add to scene
    const listener = new Three.AudioListener();
    if (camera) {
      camera.add(listener);
    } else {
      console.error('Camera is not defined');
    }

    const sound = new Three.PositionalAudio(listener);
    sound.setMediaElementSource(audio);
    audioMesh.add(sound);
    audioMesh.asset_file_path = objectURL;

    // Attempt to play the audio
    // audio.play().catch((error) => {
    //   console.error('Audio playback failed:', error);
    // });

    // audioUrls.push(objectURL);
    // audioFileName.push(file.name);
    // audioScaleX.push(1);
    // audioScaleY.push(1);
    store.dispatch(setAudioScales({ x: 1, y: 1 }));

    //  redux works here

    const ext = (file.name.match(/\.(mp3|wav|ogg)$/i) || [])[1];
    const asset_file_type = ext ? ext.toLowerCase() : 'mp3';
    audioMesh.userData = audioMesh.userData || {};
    audioMesh.userData.file_name = file.name;
    audioMesh.userData.audio_settings = { audio_source: objectURL };
    audioMesh.userData.asset_file_type = asset_file_type;
    audioMesh.temp_file_name = tempId;
    audioMesh.file_name = file.name;
    audioMesh.asset_file_type = asset_file_type;
    scene.add(audioMesh);
    // sceneAudios.push(audioMesh);
    audioMesh.objectURL = objectURL;
    // allIntersectedObjects.push(audioMesh);
    store.dispatch(setPushIntersectedObject(audioMesh));
    setPolyCount((prev) => prev + 1);

    selectObjectInScene(tempId);

    toast.success('Audio added to scene successfully');

    store.dispatch(addSceneAudio(audioMesh));
    store.dispatch(addAudio({ url: objectURL, name: file.name }));
    store.dispatch(add_new_assets({ type: 'audio', data: audioMesh }));
    store.dispatch(set_is_audio_editoropen(true));
    store.dispatch(setLoadingMessage(false));
  });

  audio.addEventListener('error', () => {
    // If the error occurred because the src was cleared (intentional cleanup), ignore it
    if (!audio.src || audio.src === window.location.href) return;
    toast.error('Failed to load audio file');
    store.dispatch(setLoadingMessage(false));
  });
}

export function DownloadAudio(
  audioData,
  { projectId, Three, scene, transformControls, selectedObject, audio }
) {
  audioData.forEach((_audioData) => {
    var audioPath = _audioData.asset_file_path;

    var position_x = _audioData.position_x;
    var position_y = _audioData.position_y;
    var position_z = _audioData.position_z;

    var rotation_x = _audioData.rotation_x;
    var rotation_y = _audioData.rotation_y;
    var rotation_z = _audioData.rotation_z;

    var scale_x = _audioData.scale_x;
    var scale_y = _audioData.scale_y;
    var scale_z = _audioData.scale_z;
    // audioUrls.push(_audioData.asset_file_path);
    // audioFileName.push(_audioData.asset_file_path);

    store.dispatch(
      addAudio({
        url: _audioData.asset_file_path,
        name: _audioData.asset_file_path,
      })
    );

    audio = document.createElement('audio');
    if (audio) {
      audio.autoplay = false;
      audio.crossOrigin = 'anonymous';

      audio.addEventListener('loadeddata', async function () {
        // Calculate plane dimensions
        const defaultWidth = 1;
        const defaultHeight = 1;
        let planeWidthv = defaultWidth;
        let planeHeightv = defaultHeight;

        // Load audio icon texture from SVG
        const texture = loadAudioIconTexture(Three, AudioIcon);

        let audio_material = new Three.MeshStandardMaterial({
          map: texture,
          side: Three.DoubleSide,
          color: 0xffffff, // White color as fallback
        });

        let geometryaudio = new Three.PlaneGeometry(planeWidthv, planeHeightv);
        const planeAudio = new Three.Mesh(geometryaudio, audio_material);
        planeAudio.castShadow = true;
        planeAudio.receiveShadow = true;
        // planeAudio.rotation.z=Math.PI/2;

        planeAudio.name = _audioData._id;
        planeAudio.url = _audioData._id;
        planeAudio.file_name = _audioData.file_name;
        planeAudio.deleteType = 'audio';
        // audioScaleX.push(planeWidthv);
        // audioScaleY.push(planeHeightv);
        store.dispatch(setAudioScales({ x: planeWidthv, y: planeHeightv }));

        planeAudio.rotation.eulerOrder = 'XYZ';
        planeAudio.rotation.order = 'XYZ';

        planeAudio.position.set(position_x, position_y, position_z);
        planeAudio.scale.set(
          scale_x / planeWidthv,
          scale_y / planeHeightv,
          scale_z
        );
        planeAudio.rotation.set(
          Three.MathUtils.degToRad(rotation_x),
          Three.MathUtils.degToRad(rotation_y),
          Three.MathUtils.degToRad(rotation_z)
        );
        planeAudio.updateMatrix();
        planeAudio.userData = planeAudio.userData || {};
        planeAudio.userData.file_name = _audioData.file_name;
        planeAudio.userData.audio_settings = _audioData.audio_settings || {};
        planeAudio.events = _audioData.events || [];
        planeAudio.asset_file_path = _audioData.asset_file_path;
        planeAudio.audioElement = audio;
        planeAudio.temp_file_name = _audioData.temp_file_name;
        applyStoredPivotToObject(planeAudio, _audioData, {
          projectId:
            typeof window !== 'undefined'
              ? window.location?.pathname?.split('/').filter(Boolean).pop()
              : null,
          cacheKeys: [
            _audioData._id,
            _audioData.id,
            _audioData.name,
            _audioData.temp_file_name,
            _audioData.file_name,
            _audioData.url,
          ],
        });
        scene.add(planeAudio);

        selectedObject = planeAudio;
        store.dispatch(
          selected_object({
            name: planeAudio.name,
            url: planeAudio.url,
            deleteType: planeAudio.deleteType,
            position: planeAudio.position.toArray(),
            rotation: planeAudio.rotation.toArray(),
            scale: planeAudio.scale.toArray(),
          })
        );
        // sceneAudios.push(planeAudio);
        // allIntersectedObjects.push(planeAudio);
        store.dispatch(setPushIntersectedObject(planeAudio));
        selectObjectInScene(_audioData._id);
        store.dispatch(addSceneAudio(planeAudio));
      });
      audio.addEventListener('error', function () {
        console.error('Error loading audio:', audio.error);
      });
      audio.src = _audioData.asset_file_path;
      audio.load();
    }
  });
}

// Function to load SVG as texture
function loadAudioIconTexture(Three, iconPath) {
  const loader = new Three.TextureLoader();
  const texture = loader.load(iconPath);

  // texture.flipY = false; // Ensure correct orientation
  return texture;
}

export function duplicateAudioAsset(
  item,
  { Three, scene, transformControls, selectedObject, camera, setPolyCount },
  setPendingUploads,
  originalMesh = null,
  options = {}
) {
  const attachToParent = options.attachToParent || null;
  const localTransform = options.localTransform || null;

  if (!item) {
    toast.error(
      'Valid item with file path and name are required for duplication'
    );
    return;
  }

  if (attachToParent && originalMesh?.isObject3D) {
    const baseName = (
      originalMesh.file_name ||
      item.file_name ||
      originalMesh.name ||
      'Audio'
    ).replace(/\.[^/.]+$/, '');
    const ext =
      (item.file_name && item.file_name.match(/\.[^/.]+$/)?.[0]) ||
      originalMesh.file_name?.match(/\.[^/.]+$/)?.[0] ||
      '';
    const duplicateFileName = getNextCopyName(scene, baseName) + ext;
    const tempId = buildTempFileName(duplicateFileName);
    const cloned = originalMesh.clone(true);
    cloned.uuid = Three.MathUtils.generateUUID();
    cloned.name = tempId;
    cloned.url = tempId;
    cloned._id = tempId;
    cloned.temp_file_name = tempId;
    cloned.file_name = duplicateFileName;
    cloned.deleteType = 'audio';
    attachToParent.add(cloned);
    if (localTransform) {
      cloned.position.copy(localTransform.position);
      cloned.rotation.copy(localTransform.rotation);
      cloned.scale.copy(localTransform.scale);
    } else {
      cloned.position.copy(originalMesh.position);
      cloned.rotation.copy(originalMesh.rotation);
      cloned.scale.copy(originalMesh.scale);
    }
    cloned.updateMatrixWorld(true);
    store.dispatch(setPushIntersectedObject(cloned));
    store.dispatch(addSceneAudio(cloned));
    copyPhysicsToDuplicate(originalMesh, cloned);
    const parentId =
      attachToParent._id || attachToParent.name || attachToParent.url;
    const list = store.getState().assets_object?.assets_data?.audio || [];
    store.dispatch(
      update_assets_data({
        type: 'audio',
        data: [
          ...list,
          {
            _id: tempId,
            id: tempId,
            name: tempId,
            file_name: duplicateFileName,
            parent: parentId,
            deleteType: 'audio',
          },
        ],
      })
    );
    return cloned;
  }

  // When item has localFile but no asset_file_path/file_name, use handleAudioUpload logic
  if (item.localFile && (!item.asset_file_path || !item.file_name)) {
    const file = item.localFile;
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      toast.error(
        () => (
          <div className="flex justify-between items-center">
            <span>File size should not exceed 5MB.</span>
          </div>
        ),
        {
          duration: 3000,
          style: { background: '#1d1e21', color: '#fff' },
        }
      );
      return;
    }
    selectedObject = null;
    store.dispatch(selected_object(null));
    transformControls?.detach();
    store.dispatch(setLoadingMessage(true));

    const objectURL = URL.createObjectURL(file);
    // Use item.file_name if available (handles renamed audio), otherwise fall back to file.name
    const nameToUse = item.file_name || item.asset_file_name || file.name;
    const baseName = nameToUse.replace(/\.[^/.]+$/, '');
    // Get extension from item.file_name first, then fall back to file extension
    const ext =
      (item.file_name && item.file_name.match(/\.[^/.]+$/)?.[0]) ||
      nameToUse.match(/\.[^/.]+$/)?.[0] ||
      file.name.match(/\.[^/.]+$/)?.[0] ||
      '';
    const duplicateFileName = getNextCopyName(scene, baseName) + ext;
    const tempId = buildTempFileName(duplicateFileName);

    const audio = document.createElement('audio');
    audio.autoplay = false;
    audio.src = objectURL;
    audio.crossOrigin = 'anonymous';
    audio.load();

    audio.addEventListener('loadeddata', () => {
      const texture = loadAudioIconTexture(Three, AudioIcon);
      const material = new Three.MeshStandardMaterial({
        map: texture,
        side: Three.DoubleSide,
      });
      const geometry = new Three.PlaneGeometry(1, 1);
      const audioMesh = new Three.Mesh(geometry, material);
      audioMesh.castShadow = true;
      audioMesh.receiveShadow = true;

      audioMesh.name = tempId;
      audioMesh.objPath = file;
      audioMesh.url = tempId;
      audioMesh._id = tempId;
      audioMesh.file_name = duplicateFileName;
      audioMesh.deleteType = 'audio';
      audioMesh.originalFile = file;
      audioMesh.localFile = file;

      if (setPendingUploads) {
        const sourceMesh = originalMesh || scene.getObjectByName(item?._id || item?.id || item?.url || item?.name);

        setPendingUploads((prev) => [
          ...prev,
          {
            file: file,
            transform: {
              position_x: sourceMesh?.position?.x || 0,
              position_y: sourceMesh?.position?.y || 0,
              position_z: sourceMesh?.position?.z || 0,
              rotation_x: Three.MathUtils.radToDeg(sourceMesh?.rotation?.x || 0),
              rotation_y: Three.MathUtils.radToDeg(sourceMesh?.rotation?.y || 0),
              rotation_z: Three.MathUtils.radToDeg(sourceMesh?.rotation?.z || 0),
              scale_x: sourceMesh?.scale?.x || 1,
              scale_y: sourceMesh?.scale?.y || 1,
              scale_z: sourceMesh?.scale?.z || 1,
            },
            tempId: tempId,
          },
        ]);

        audioMesh.position.set(
          sourceMesh?.position?.x || 0,
          sourceMesh?.position?.y || 0,
          sourceMesh?.position?.z || 0
        );
        audioMesh.rotation.copy(sourceMesh?.rotation || new Three.Euler());
        audioMesh.scale.copy(sourceMesh?.scale || new Three.Vector3(1, 1, 1));
      }

      const listener = new Three.AudioListener();
      if (camera) {
        camera.add(listener);
      } else {
        console.error('Camera is not defined');
      }
      const sound = new Three.PositionalAudio(listener);
      sound.setMediaElementSource(audio);
      audioMesh.add(sound);
      audioMesh.asset_file_path = objectURL;

      const ext = (file.name.match(/\.(mp3|wav|ogg)$/i) || [])[1];
      const asset_file_type = ext ? ext.toLowerCase() : 'mp3';
      audioMesh.userData = audioMesh.userData || {};
      audioMesh.userData.file_name = duplicateFileName;
      audioMesh.userData.audio_settings = { audio_source: objectURL };
      audioMesh.userData.asset_file_type = asset_file_type;
      audioMesh.temp_file_name = tempId;
      audioMesh.asset_file_type = asset_file_type;

      store.dispatch(setAudioScales({ x: 1, y: 1 }));
      scene.add(audioMesh);
      audioMesh.objectURL = objectURL;
      store.dispatch(setPushIntersectedObject(audioMesh));
      if (setPolyCount) setPolyCount((prev) => prev + 1);
      selectObjectInScene(tempId);
      toast.success('Audio added to scene successfully');
      store.dispatch(addSceneAudio(audioMesh));
      store.dispatch(addAudio({ url: objectURL, name: duplicateFileName }));
      store.dispatch(add_new_assets({ type: 'audio', data: audioMesh }));
      store.dispatch(set_is_audio_editoropen(true));
      store.dispatch(setLoadingMessage(false));
    });

    audio.addEventListener('error', () => {
      toast.error('Failed to load audio file');
      store.dispatch(setLoadingMessage(false));
    });
    return;
  }

  if (!item.asset_file_path || !item.file_name) {
    toast.error(
      'Valid item with file path and name are required for duplication'
    );
    return;
  }

  // Clear current selection
  selectedObject = null;
  store.dispatch(selected_object(null));
  transformControls?.detach();

  // Set loading state
  store.dispatch(setLoadingMessage(true));

  // Generate unique properties for duplicate
  const baseName = item.file_name.replace(/\.[^/.]+$/, ''); // strip extension
  const duplicateFileName =
    getNextCopyName(scene, baseName) +
    (item.file_name.match(/\.[^/.]+$/)?.[0] || '');

  const tempId = buildTempFileName(duplicateFileName);
  const duplicateAudioCode = `mesh_${Math.random().toString(36).substr(2, 6)}`;

  // Create audio element
  const audio = document.createElement('audio');
  audio.autoplay = false;
  audio.crossOrigin = 'anonymous';
  audio.src = item.asset_file_path;
  audio.load();

  audio.addEventListener('loadeddata', () => {
    // Load audio icon texture
    const texture = loadAudioIconTexture(Three, AudioIcon);

    // Create material with audio icon
    const material = new Three.MeshStandardMaterial({
      map: texture,
      side: Three.DoubleSide,
      color: 0xffffff,
    });

    // Create geometry and mesh
    const geometry = new Three.PlaneGeometry(1, 1);
    const duplicatedMesh = new Three.Mesh(geometry, material);
    duplicatedMesh.castShadow = true;
    duplicatedMesh.receiveShadow = true;
    duplicatedMesh.scale.x = -duplicatedMesh.scale.x;

    // Set basic properties - use consistent id for scene lookup, remove, and publish
    duplicatedMesh.name = tempId;
    duplicatedMesh.url = tempId;
    duplicatedMesh._id = tempId;
    duplicatedMesh.file_name = duplicateFileName;
    duplicatedMesh.deleteType = 'audio';
    duplicatedMesh.asset_file_path = item.asset_file_path;
    duplicatedMesh.asset_file_pathh = item.asset_file_path;
    if (item.objPath instanceof File) {
      duplicatedMesh.objPath = item.objPath;
      duplicatedMesh.originalFile = item.originalFile || item.objPath;
    }
    const dupAssetFileType = (() => {
      const fromItem = item.asset_file_type || item.userData?.asset_file_type;
      if (fromItem && /^(mp3|wav|ogg)$/i.test(fromItem))
        return fromItem.toLowerCase();
      const ext = (duplicateFileName.match(/\.(mp3|wav|ogg)$/i) || [])[1];
      return ext ? ext.toLowerCase() : 'mp3';
    })();
    duplicatedMesh.asset_file_type = dupAssetFileType;
    // Prioritize scene object (tempMesh or originalMesh) for current transform
    const sourceMesh = originalMesh || scene.getObjectByName(item?._id || item?.id || item?.url || item?.name);

    // Use transform from scene object when present (e.g. just added before publish);
    // otherwise use item.position_x etc. (saved/loaded data)
    if (sourceMesh) {
      duplicatedMesh.position.set(
        sourceMesh.position.x,
        sourceMesh.position.y,
        sourceMesh.position.z
      );
      duplicatedMesh.rotation.copy(sourceMesh.rotation);
      duplicatedMesh.scale.copy(sourceMesh.scale);
    } else {
      const posX = item.position_x ?? item.position?.x ?? 0;
      const posY = item.position_y ?? item.position?.y ?? 0;
      const posZ = item.position_z ?? item.position?.z ?? 0;
      duplicatedMesh.position.set(posX, posY, posZ);

      const rotX = Three.MathUtils.degToRad(item.rotation_x ?? item.rotation?.x ?? 0);
      const rotY = Three.MathUtils.degToRad(item.rotation_y ?? item.rotation?.y ?? 0);
      const rotZ = Three.MathUtils.degToRad(item.rotation_z ?? item.rotation?.z ?? 0);
      duplicatedMesh.rotation.set(rotX, rotY, rotZ);

      duplicatedMesh.scale.set(
        item.scale_x ?? item.scale?.x ?? 1,
        item.scale_y ?? item.scale?.y ?? 1,
        item.scale_z ?? item.scale?.z ?? 1
      );
    }

    // Add audio listener and sound
    const listener = new Three.AudioListener();
    if (camera) {
      camera.add(listener);
    }

    const sound = new Three.PositionalAudio(listener);
    sound.setMediaElementSource(audio);
    duplicatedMesh.add(sound);

    // Store all item properties in userData (use mesh transform so it works before publish)
    const rotXDeg =
      item.rotation_x ?? Three.MathUtils.radToDeg(duplicatedMesh.rotation.x);
    const rotYDeg =
      item.rotation_y ?? Three.MathUtils.radToDeg(duplicatedMesh.rotation.y);
    const rotZDeg =
      item.rotation_z ?? Three.MathUtils.radToDeg(duplicatedMesh.rotation.z);
    duplicatedMesh.userData = {
      audio_settings: { ...(item.audio_settings || {}) },
      project: item.project,
      user: item.user,
      asset_file_name: item.asset_file_name,
      file_name: duplicateFileName,
      asset_file_type: dupAssetFileType,
      asset_file_path: item.asset_file_path,
      published: item.published,
      asset_thumbnail: item.asset_thumbnail,
      position_x: duplicatedMesh.position.x,
      position_y: duplicatedMesh.position.y,
      position_z: duplicatedMesh.position.z,
      scale_x: duplicatedMesh.scale.x,
      scale_y: duplicatedMesh.scale.y,
      scale_z: duplicatedMesh.scale.z,
      rotation_x: rotXDeg,
      rotation_y: rotYDeg,
      rotation_z: rotZDeg,
      events: [...(item.events || [])], // Copy events array
      saved: false, // Mark as unsaved since it's a duplicate
      audio_code: duplicateAudioCode,
      originalId: item._id || item.id, // Reference to original item
      isDuplicate: true,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };

    // Handle pending uploads if needed
    if (setPendingUploads && originalMesh?.originalFile) {
      setPendingUploads((prev) => [
        ...prev,
        {
          file: originalMesh.originalFile,
          transform: {
            position_x: duplicatedMesh.position.x,
            position_y: duplicatedMesh.position.y,
            position_z: duplicatedMesh.position.z,
            rotation_x: item.rotation_x || 0,
            rotation_y: item.rotation_y || 0,
            rotation_z: item.rotation_z || 0,
            scale_x: duplicatedMesh.scale.x,
            scale_y: duplicatedMesh.scale.y,
            scale_z: duplicatedMesh.scale.z,
          },
          tempId: tempId,
          itemData: duplicatedMesh.userData, // Include all item data
        },
      ]);
    }

    // Add to scene
    scene.add(duplicatedMesh);

    // Update Redux store
    store.dispatch(setAudioScales({ x: 1, y: 1 }));
    store.dispatch(setPushIntersectedObject(duplicatedMesh));
    store.dispatch(addSceneAudio(duplicatedMesh));
    copyPhysicsToDuplicate(item, duplicatedMesh);
    store.dispatch(
      addAudio({ url: item.asset_file_path, name: duplicateFileName })
    );

    // // Show success message
    // toast.success(`Audio duplicated successfully as "${duplicateFileName}"`);
    const displayName =
      tempId.length > 30 ? `${tempId.substring(0, 30)}...` : tempId;
    toast.success(`Audio duplicated as "${displayName}"`);

    // Update Redux store with new asset - use mesh transform (valid when duplicating before publish)
    const duplicateItemData = {
      ...item,
      _id: tempId,
      id: tempId,
      temp_file_name: tempId,
      file_name: duplicateFileName,
      audio_code: duplicateAudioCode,
      position_x: duplicatedMesh.position.x,
      position_y: duplicatedMesh.position.y,
      position_z: duplicatedMesh.position.z,
      rotation_x: rotXDeg,
      rotation_y: rotYDeg,
      rotation_z: rotZDeg,
      parent: undefined,
      saved: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      originalId: item._id || item.id,
      isDuplicate: true,
    };

    store.dispatch(
      add_new_assets({
        type: 'audio',
        data: duplicatedMesh,
        itemData: duplicateItemData,
      })
    );
    store.dispatch(set_is_audio_editoropen(true));
    store.dispatch(selected_object(duplicatedMesh));
    store.dispatch(setLoadingMessage(false));
  });

  audio.addEventListener('error', (error) => {
    // If the error occurred because the src was cleared (intentional cleanup), ignore it
    if (!audio.src || audio.src === window.location.href) return;
    console.error('Error duplicating audio:', error);
    toast.error('Failed to duplicate audio asset');
    store.dispatch(setLoadingMessage(false));
  });
}
